import { atom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';

import { Notification } from '@/types/notification';
import { User } from '@/types/user';

export const NotificationAtom = atom<Notification | null>(null);

export const SidebarOpenAtom = atom<boolean>(false);

export const LineUserAtom = atom<LineUser | null>(null);

export const UserAtom = atomWithStorage<User | null>('user', null, undefined, { getOnInit: true });
